/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';
export const yaNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            {
                id: 'ya.dashboard.main',
                title: 'Main',
                type: 'basic',
                icon: 'heroicons_outline:chart-pie',
                link: '/ya/dashboards'
            }
        ]
    },
    {
        id: 'settings',
        title: 'Settings',
        type: 'group',
        icon: 'heroicons_outline:cog',
        children: [
            {
                id: 'ya.settings.api-keys',
                title: 'API Keys',
                type: 'basic',
                icon: 'heroicons_outline:key',
                link: '/ya/settings/api-keys',
            },
            {
                id: 'ya.settings.business',
                title: 'Businesses',
                type: 'basic',
                icon: 'heroicons_outline:building-office',
                link: '/ya/settings/businesses',
            },
            {
                id: 'ya.settings.notification',
                title: 'Notifications',
                type: 'basic',
                icon: 'heroicons_outline:bell',
                link: '/ya/settings/notifications',
            },
            {
                id: 'ya.settings.feedback',
                title: 'Feedbacks',
                type: 'basic',
                icon: 'heroicons_outline:star',
                link: '/ya/settings/feedbacks',
            }
        ]

    },
    {
        id: 'order',
        title: 'Orders',
        type: 'group',
        icon: 'heroicons_outline:shopping-cart',
        children: [
            {
                id: 'ya.order.fbs',
                title: 'FBS Orders',
                type: 'collapsable',
                icon: 'heroicons_outline:document-text',
                children: [
                    {
                        id: 'ya.order.fbs.new',
                        title: 'New',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/ya/orders/fbs/new',
                    },
                    {
                        id: 'ya.order.fbs.active-shipment',
                        title: 'Active Shipment',
                        type: 'basic',
                        icon: 'heroicons_outline:shopping-bag',
                        link: '/ya/orders/fbs/active-shipment',
                    },
                    /*{
                        id: 'order.fbs.packing',
                        title: 'Packing',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/ya/orders/fbs/packings',
                    },
                    {
                        id: 'order.fbs.supply',
                        title: 'Supply',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/ya/orders/fbs/supply/invoices',
                    },
                    {
                        id: 'order.fbs.pending-delivery',
                        title: 'Pending Delivery',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/ya/orders/fbs/pending-deliveries',
                    },
                    /!*{
                        id: 'order.fbs.delivering',
                        title: 'Delivering',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/orders/fbs/delivering',
                    },*!/
                    {
                        id: 'order.fbs.delivered',
                        title: 'Delivered',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/ya/orders/fbs/delivered',
                    },
                    {
                        id: 'order.fbs.accepted-at-dp',
                        title: 'Accepted at DP',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/ya/orders/fbs/accepted-at-dp',
                        hidden: (order) => true
                    },
                    {
                        id: 'order.fbs.delivered-to-customer',
                        title: 'Delivered to Customer',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/ya/orders/fbs/delivered-to-customer',
                    },
                    {
                        id: 'order.fbs.completed',
                        title: 'Completed',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/ya/orders/fbs/completed',
                    },
                    {
                        id: 'order.fbs.cancelled',
                        title: 'Cancelled',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/ya/orders/fbs/cancelled',
                    },
                    {
                        id: 'order.fbs.pending-cancellation',
                        title: 'Pending Cancellation',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/ya/orders/fbs/pending-cancellation',
                        hidden: (order) => true
                    },
                    {
                        id: 'order.fbs.returned',
                        title: 'Returned',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/ya/orders/fbs/returned',
                    }*/
                ]
            },
        ]
    },
    {
        id: 'ya.fby',
        title: 'FBY',
        type: 'group',
        children: [
            {
                id: 'ya.fby.supply',
                title: 'Supplies',
                type: 'basic',
                icon: 'heroicons_outline:truck',
                link: '/ya/reports/supplies',
            }
        ]
    },
    {
        id: 'unit',
        title: 'Units',
        type: 'group',
        icon: 'heroicons_outline:cube',
        children: [
            {
                id: 'unit.assortment',
                title: 'Assortments',
                type: 'basic',
                icon: 'heroicons_outline:document-text',
                link: '/ya/units/assortments',
            }

        ]

    },
    {
        id: 'report',
        title: 'Reports',
        type: 'group',
        icon: 'heroicons_outline:document-chart-bar',
        children: [
            {
                id: 'ya.report.sales',
                title: 'Sales',
                type: 'basic',
                icon: 'heroicons_outline:document-text',
                link: '/ya/reports/sales',

            },
            {
                id: 'ya.report.returns',
                title: 'Returns',
                type: 'basic',
                icon: 'heroicons_outline:document-text',
                link: '/ya/reports/returns',
            }
        ]
    },

]
export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            {
                id: 'dashboard.main',
                title: 'Main',
                type: 'basic',
                icon: 'heroicons_outline:chart-pie',
                link: '/dashboards/home'
            },
            {
                id: 'dashboard.hourly-counts',
                title: 'Statistics',
                subtitle: 'dashboard.hourly-counts-subtitle',
                type: 'basic',
                icon: 'heroicons_outline:chart-bar',
                link: '/dashboards/hourly-counts'
            },
            {
                id: 'dashboard.monthly',
                title: 'Monthly Report',
                type: 'basic',
                icon: 'heroicons_outline:chart-bar',
                link: '/dashboards/monthly'
            },
            {
                id: 'dashboard.issued-orders',
                title: 'Issued orders',
                type: 'basic',
                icon: 'heroicons_outline:check-circle',
                link: '/dashboards/issued-orders',
            }
        ]
    },
    {
        id: 'marketing',
        title: 'Marketing',
        type: 'group',
        children: [
            {
                id: 'marketing.ad-campaign',
                title: 'Advertisment',
                type: 'basic',
                icon: 'heroicons_outline:chart-bar',
                link: '/marketing/ad-campaigns',
            },
            {
                id: 'marketing.promotions',
                title: 'Promotions',
                type: 'basic',
                icon: 'heroicons_outline:tag',
                link: '/marketing/promotions',
                badge: {
                    title: 'NEW',
                    classes: 'px-2 py-0.5 bg-primary text-on-primary rounded-full text-xs font-semibold',
                },
            }
        ]
    },
    {
        id: 'document',
        title: 'Documents',
        type: 'group',
        icon: 'heroicons_outline:book-open',
        children: [
            {
                id   : 'document.invoice',
                title: 'Invoices',
                type : 'basic',
                icon : 'heroicons_outline:document-text',
                link : '/invoices',
            },
            // {
            //     id: 'document.tms',
            //     title: 'TMS',
            //     type: 'basic',
            //     icon: 'heroicons_outline:document-text',
            //     link: '/docs/tms'
            // }
        ]

    },
    {
        id: 'report',
        title: 'Reports',
        type: 'group',
        icon: 'heroicons_outline:document-chart-bar',
        children: [
            {
                id: 'report.remainders',
                title: 'Remainders',
                type: 'basic',
                icon: 'heroicons_outline:document-text',
                link: '/reports/reminders',

            },
            {
                id: 'report.out-of-stock',
                title: 'Out of Stock',
                type: 'basic',
                icon: 'heroicons_outline:document-text',
                link: '/reports/out-of-stocks',

            },
            {
                id: 'report.non-liquid',
                title: 'Non Liquid Reports',
                type: 'basic',
                icon: 'heroicons_outline:document-text',
                link: '/reports/non-liquids',

            },
            {
                id: 'report.paid-storage-sku',
                title: 'Paid Storage SKU Reports',
                subtitle: 'report.paid-storage-sku-subtitle',
                type: 'basic',
                icon: 'heroicons_outline:document-text',
                link: '/reports/paid-storage-skus',

            },
            {
                id: 'report.return-item',
                title: 'Return Items Report',
                type: 'basic',
                icon: 'heroicons_outline:document-text',
                link: '/reports/return-items',

            },
            {
                id: 'report.paid-goods',
                title: 'Paid Goods Report',
                type: 'basic',
                icon: 'heroicons_outline:document-text',
                link: '/reports/paid-goods',

            },
            {
                id: 'report.stock-inventory',
                title: 'Stock Inventory Report',
                type: 'basic',
                icon: 'heroicons_outline:document-text',
                link: '/reports/stock-inventories',
            },
            {
                id: 'report.missing-report',
                title: 'Missing Report',
                type: 'basic',
                icon: 'heroicons_outline:document-text',
                link: '/reports/missing-reports',
            },
            {
                id: 'report.expenses',
                title: 'Expenses',
                type: 'basic',
                icon: 'heroicons_outline:banknotes',
                link: '/reports/expenses',
                badge: {
                    title: 'NEW',
                    classes: 'px-2 py-0.5 bg-primary text-on-primary rounded-full text-xs font-semibold',
                },
            },
            {
                id: 'report.defected',
                title: 'Defected',
                type: 'basic',
                icon: 'heroicons_outline:exclamation-triangle',
                link: '/reports/defected',
                badge: {
                    title: 'NEW',
                    classes: 'px-2 py-0.5 bg-primary text-on-primary rounded-full text-xs font-semibold',
                },
            },
        ]
    },
    {
        id: 'shop',
        title: 'Shops',
        type: 'group',
        icon: 'heroicons_outline:shopping-bag',
        children: [
            {
                'id': 'shop.product',
                'title': 'Products',
                'type': 'basic',
                'icon': 'heroicons_outline:shopping-bag',
                'link': '/shops/products',
            },
            {
                id: 'shop.card-copy',
                title: 'Card Copy',
                type: 'basic',
                icon: 'heroicons_outline:document-duplicate',
                link: '/shops/card-copies',
            },
            {
                id: 'shop.sku-health',
                title: 'SKU Product Health',
                type: 'basic',
                icon: 'heroicons_outline:heart',
                link: '/reports/sku-health',
            }
        ]
    },
    {
        id: 'order',
        title: 'Orders',
        type: 'group',
        icon: 'heroicons_outline:shopping-cart',
        children: [
            {
                id: 'order.fbs',
                title: 'FBS Orders',
                type: 'collapsable',
                icon: 'heroicons_outline:document-text',
                children: [
                    {
                        id: 'order.fbs.new',
                        title: 'New',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/orders/fbs/new',
                    },
                    {
                        id: 'order.fbs.packing',
                        title: 'Packing',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/orders/fbs/packings',
                    },
                    {
                        id: 'order.fbs.supply',
                        title: 'Supply',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/orders/fbs/supply/invoices',
                    },
                    {
                        id: 'order.fbs.pending-delivery',
                        title: 'Pending Delivery',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/orders/fbs/pending-deliveries',
                    },
                    /*{
                        id: 'order.fbs.delivering',
                        title: 'Delivering',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/orders/fbs/delivering',
                    },*/
                    {
                        id: 'order.fbs.delivered',
                        title: 'Delivered',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/orders/fbs/delivered',
                    },
                    {
                        id: 'order.fbs.accepted-at-dp',
                        title: 'Accepted at DP',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/orders/fbs/accepted-at-dp',
                        hidden: (order) => true
                    },
                    {
                        id: 'order.fbs.delivered-to-customer',
                        title: 'Delivered to Customer',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/orders/fbs/delivered-to-customer',
                    },
                    {
                        id: 'order.fbs.completed',
                        title: 'Completed',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/orders/fbs/completed',
                    },
                    {
                        id: 'order.fbs.cancelled',
                        title: 'Cancelled',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/orders/fbs/cancelled',
                    },
                    {
                        id: 'order.fbs.pending-cancellation',
                        title: 'Pending Cancellation',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/orders/fbs/pending-cancellation',
                        hidden: (order) => true
                    },
                    {
                        id: 'order.fbs.returned',
                        title: 'Returned',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/orders/fbs/returned',
                    },
                    {
                        id: 'order.fbs.returns',
                        title: 'Goods in return',
                        type: 'basic',
                        icon: 'heroicons_outline:receipt-refund',
                        link: '/orders/fbs/returns',
                    }
                ]
            },
            {
                id: 'order.dbs',
                title: 'DBS Orders',
                type: 'collapsable',
                icon: 'heroicons_outline:document-text',
                children: [
                    {
                        id: 'order.dbs.new',
                        title: 'New',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/orders/dbs/new',
                    },
                    {
                        id: 'order.dbs.packing',
                        title: 'Packing',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/orders/dbs/packings',
                    },
                    {
                        id: 'order.dbs.delivering',
                        title: 'Delivering',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/orders/dbs/delivering',
                    },
                    {
                        id: 'order.dbs.completed',
                        title: 'Completed',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/orders/dbs/completed'
                    },
                    {
                        id: 'order.dbs.cancelled',
                        title: 'Cancelled Orders',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/orders/dbs/cancelled'
                    },
                    {
                        id: 'order.dbs.returned',
                        title: 'Returned',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/orders/dbs/returned',
                    }
                ]
            },
            {
                id: 'order.fbs.statistics',
                title: 'Statistics',
                type: 'basic',
                icon: 'heroicons_outline:chart-pie',
                link: '/orders/fbs/statistics',
            },
            {
                id: 'order-fbs-dbs-residuals',
                title: 'FBS/DBS Residuals',
                type: 'basic',
                icon: 'heroicons_outline:document-text',
                link: '/orders/fbs-dbs-residuals'
            }
        ]
    },
    {
        id: 'unit',
        title: 'Units',
        type: 'group',
        icon: 'heroicons_outline:cube',
        children: [
            {
                id: 'unit.assortment',
                title: 'Assortments',
                type: 'basic',
                icon: 'heroicons_outline:document-text',
                link: '/units/assortments',
            },
            {
                id: 'unit.sku-prices',
                title: 'SKU Prices',
                type: 'basic',
                icon: 'heroicons_outline:currency-dollar',
                link: '/units/sku-prices',
            },
            {
                id: 'unit.current',
                title: 'Current',
                type: 'basic',
                icon: 'heroicons_outline:document-text',
                link: '/units/currents',
            },
            {
                id: 'unit.fact',
                title: 'Fact',
                type: 'basic',
                icon: 'heroicons_outline:document-text',
                link: '/units/facts',
            },
            {
                id: 'unit.weight-dimension',
                title: 'Weight Dimension',
                type: 'basic',
                icon: 'heroicons_outline:scale',
                link: '/units/weight-dimension',
            },

        ]

    },
    {
        id: 'settings',
        title: 'Settings',
        type: 'group',
        icon: 'heroicons_outline:cog',
        children: [
            {
                id: 'settings.general',
                title: 'General',
                type: 'basic',
                icon: 'heroicons_outline:cog-6-tooth',
                link: '/settings/general'
            },
            {
                id: 'settings.shop',
                title: 'Shops',
                type: 'basic',
                icon: 'heroicons_outline:building-storefront',
                link: '/settings/shops'
            },
            {
                id: 'settings.reviews',
                title: 'Reviews',
                type: 'basic',
                icon: 'heroicons_outline:star',
                link: '/settings/reviews',
            },
            {
                id: 'settings.invoice-package',
                title: 'Invoice Packages',
                type: 'basic',
                icon: 'heroicons_outline:document-text',
                link: '/settings/invoice-packages',
            },
            {
                id: 'settings.credits',
                title: 'Credits',
                type: 'basic',
                icon: 'heroicons_outline:sparkles',
                link: '/settings/credits',
            },
            {
                id: 'settings.notification',
                title: 'Notifications',
                type: 'basic',
                icon: 'heroicons_outline:bell',
                link: '/settings/notifications',
            }
        ]

    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
